import { Headline } from '@almbrand/headline';
import { Modal } from '@almbrand/modal';
import { RichText } from '@almbrand/richtext';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { MobileVariation, setModal } from 'store/slices/modalSlice';

import styles from './ModalComponent.module.scss';

export const ModalComponent = ({ cssStyle }: { cssStyle?: React.CSSProperties }) => {
	const dispatch = useAppDispatch();
	const { displayModal, modalProps } = useAppSelector((state) => state.modal);

	const [mobileVariation, setMobileVariation] = useState<MobileVariation>('fullWidth');

	useEffect(() => {
		handleMobileSize();
	}, [displayModal, modalProps]);

	const handleMobileSize = () => {
		if (modalProps?.mobileVariation) {
			setMobileVariation(modalProps.mobileVariation);
			return;
		}
		for (const field of modalProps?.fields ?? []) {
			// for now only support select/search fields, but we can add more conditions for other field types if needed
			// full height since we'll need space for the options dropdown
			const contentType = field?.props?.contentType;
			if (contentType === 'SelectFieldBlock' || contentType === 'SearchFieldBlock') {
				setMobileVariation('fullHeightFullWidth');
			}
		}
	};

	const handleClose = () => dispatch(setModal({ displayModal: false }));

	const getContent = () => {
		// If content is a string, render it as rich text. If it's a React node, render it directly.
		if (modalProps?.content) {
			if (typeof modalProps.content === 'string') {
				return (
					<RichText
						description={modalProps.content}
						className={
							(modalProps.className, modalProps.isErrorModal ? styles.ModalComponent__error : undefined)
						}
					/>
				);
			}
			return modalProps.content;
		}
		return null;
	};

	return (
		<div style={cssStyle}>
			<Modal
				{...modalProps}
				mode='default'
				mobileVariation={mobileVariation}
				handleClose={handleClose}
			>
				{
					<div className={styles.ModalComponent}>
						{modalProps?.subtitle && (
							<div className={styles.ModalComponent__headline}>
								<Headline
									fontColor='primary'
									size='default'
									title={modalProps?.subtitle}
									variant='h2'
								/>
							</div>
						)}
						{getContent()}
						{modalProps?.fields?.map((field, idx) => <div key={idx + '_'}>{field}</div>)}
					</div>
				}
			</Modal>
		</div>
	);
};
